import React from 'react'
import AboutImage from '../../assets/pic.jpg'
import cv from '../../assets/Tushar Borse(Front-end Engineer).pdf'
import {HiDownload} from 'react-icons/hi'
import Card from '../../components/Card'
import data from './data'
import './about.css'


const About = () => {
  return (
    <section id="about" data-aos="fade-in">
      <div className='container about__container'>
        <div className='about__left'>
          <div className='about__portrait'>
            <img src={AboutImage} alt="About Image" />
          </div>
        </div>
        <div className='about__right'>
          <h2>About Me</h2>
          <div className='about__cards'>
              {
                data.map(item =>(
                  <Card key={item.id} className="about__card">
                    <span className='about__card-icon'>{item.icon}</span>
                    <h5>{item.title}</h5>
                    <small>{item.desc}</small>
                  </Card>
                ))
              }
          </div>

          <p>
              I am a Software Engineer with 2+ years of experience building production-grade web applications using React.js and JavaScript.

In my current role, I work on an IoT-based industrial monitoring platform, building data-intensive dashboards for monitoring machine health, downtime, production metrics, and operational efficiency across manufacturing plants.

My professional experience includes React.js, JavaScript, Redux, REST API integration, data visualization, reusable UI components, and frontend performance optimization.

I also have hands-on experience with the MERN stack through intensive training and project development, and I am currently strengthening my backend skills with Node.js, Express.js, and SQL to grow into a full-stack engineering role.
          </p>
          <a href={cv} download className='btn primary'>Download CV <HiDownload/></a>
        </div>
      </div>
    </section>
  )
}

export default About